/* src/app/quoting/pages/product-new/product-new.component.scss */
/*# sourceMappingURL=product-new.component.css.map */
